<template>
  <div
    class="add-vocal-file-container"
    :class="{
      [`add-vocal-file-container--${createRenderType}`]: true,
      [`add-vocal-file-cn`]: globleConfig.appname == chinaAppName,
    }"
  >
    <file-pond
      ref="refUpload"
      v-if="renderData.ifRenderFilePond"
      label-idle="歌曲文件"
      v-bind:allow-multiple="false"
      :acceptedFileTypes="renderData.acceptedFileTypes.join(',')"
      @handleAfterRead="handleAfterRead"
      @addfile="handleAddFile"
      v-bind:files="renderData.files"
    >
    </file-pond>
    <div class="add-vocal-file-main" ref="refUploadContent">
      <div class="add-vocal-new-corner-mark" v-if="vocalCornerMarkVisible">
        <span class="block">{{ $$t("common.new") }}</span>
      </div>

      <div class="add-vocal-file-selectfile pointer">
        <i class="block"></i>
        <span class="block">{{ $$t("create.song_file") }}</span>
        <label class="vip_plan" v-if="userInfo?.user?.vip_level_name != 'pro'">
          {{ $$t("create.pro_plan") }}
        </label>
      </div>
      <div class="add-vocal-file-desc">
        {{ $$t("create.vocal_file_desc") }}
      </div>
    </div>
    <div
      class="add-music-reference-edit-mask pointer"
      @click="
        (e) => {
          showSubscribeDialog();
          // goSubscribe(2, 'vocal_local_upload');
        }
      "
      v-if="userInfo?.user?.vip_level_name != 'pro'"
    ></div>
  </div>
  <EditVocal
    :editFileName="renderData.editFileName"
    v-model:visible="renderData.editFilePopupVisible"
    v-if="renderData.editFilePopupVisible"
    :clipSourceData="renderData.clipSourceData"
    @complete="handleEditFileCompleted"
  >
  </EditVocal>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import globleConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";

import ElementUpload from "@/components/basic/upload/elementUpload.jsx";
import tools from "@/utils/tools.js";
import Button from "@/components/basic/button/Button.vue";
import IconButton from "@/components/basic/button/IconButton.vue";
import EditVocal from "./editVocal.vue";

import ffmpegUtil from "@/components/media/utils/ffmpegUtil.js";
import message from "@/components/functionCallComponent/message.jsx";
import clipUtil from "@/components/media/utils/clipUtil.js";
import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";
import { validateYoutubeLink } from "@/utils/validationTools.js";
import axios from "axios";

import apiReferMusic from "@/api/api/apiReferMusic.js";
import apiCommon from "@/api/api/apiCommon.js";
import userReferMusicStore from "@/store/create/vocalMusicStore.js";
import useDraftDataStore from "@/store/create/draftDataStore.js";
import { $$language, $$t, $$tValue } from "@/i18n/i18n.js";
import { storeToRefs } from "pinia";

import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
const createLayoutStore = useCreateLayoutStore();
const userDataStore = useUserDataStore();
const { userInfo } = storeToRefs(userDataStore);
const { createRenderType, vocalCornerMarkVisible } =
  storeToRefs(createLayoutStore);

const referMusicStore = userReferMusicStore();
const draftDataStore = useDraftDataStore();
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const Router = useRouter();
// Create component
const FilePond = vueFilePond();

const refUploadContent = ref(null);
const refUpload = ref(null);
const refInput = ref(null);
const props = defineProps({});
const emits = defineEmits(["saveSuccess"]);
const acceptedFileTypes = [
  "audio/x-wav",
  "video/quicktime",
  "video/mp4",
  "audio/wav",
  "audio/x-m4a",
  "audio/flac",
  "audio/mpeg",
  ".mp3",
  ".wav",
  ".m4a",
  ".mp4",
  ".mov",
  ".MP4",
  ".flac",
];
const renderData = reactive({
  ifRenderFilePond: true,
  files: [],
  file: null,
  acceptedFileTypes: acceptedFileTypes,
  editFilePopupVisible: false,
  clipSourceData: null,
  editFileName: "",
});

const checkMediaType = (file) => {
  if (file.type.toLocaleLowerCase().startsWith("audio")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "audio"
      : "unknown";
  } else if (file.type.toLocaleLowerCase().startsWith("video")) {
    return acceptedFileTypes.includes(file.type.toLocaleLowerCase())
      ? "video"
      : "unknown";
  } else {
    return "unknown";
  }
};

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation();
  if (await userDataStore.checkLoginStatus()) {
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    });
  }
};

const showSubscribeDialog = () => {
  emits("showSubscribeDialog", "reference", {
    membership_source1: "membership_feature",
    membership_source2: "vocal_local_upload",
  });
};

const initUploadContent = () => {
  if (refUploadContent.value) {
    nextTick(() => {
      refUpload.value?.$el
        .querySelector(".filepond--drop-label")
        .appendChild(refUploadContent.value);
    });
    setTimeout(() => {
      refUpload.value?.$el
        ?.querySelector("input")
        ?.setAttribute("accept", renderData.acceptedFileTypes.join(","));
    }, 20);
  }
};

const handleSelectFile = () => {
  refUpload.value?.$el.querySelector(".filepond--drop-label").click();
};
const handleAddFile = (error, fileItem, fileList) => {
  if (error) {
    console.error("File add error:", error);
    return;
  }
  console.log("File added:", fileItem);

  handleAfterRead(fileItem.file, 2).then(() => {
    doInitEditFile();
  });
};

const handleAfterRead = (e, type = 1) => {
  return new Promise(async (resolve, reject) => {
    let fileType = checkMediaType(e);
    if (fileType == "unknown") {
      message.info({
        position: "top",
        content: $$t("create.select_audio_or_video"),
      });
      reject("not audio");
      return;
    }
    console.log("File handleAfterRead:", type, e);
    let file = null;
    let blobUrl = "";
    if (e instanceof File) {
      file = e;
    } else {
      if (e.target.files && e.target.files.length > 0) {
        file = e.target.files[0];
      }
      renderData.ifRenderFilePond = false;
      renderData.files = [];
    }
    nextTick(() => {
      renderData.ifRenderFilePond = true;
      nextTick(() => {
        initUploadContent();
      });
    });
    if (!file) return;
    if (file.size > 1024 * 1024 * 100) {
      message.info({
        position: "top",
        content: $$t("create.max_file_size"),
      });
      reject("max file size");
      return;
    }
    try {
      const duration = await tools.getMediaFileDuration(file);
      if (duration > 0) {
        if (duration < 10) {
          message.info({
            position: "top",
            content: $$tValue("create.min_file_duration", { duration: 10 }),
          });
          reject("min file duration");
        } else {
          renderData.duration = duration;
          renderData.file = file;
          resolve();
        }
      } else {
        console.log("getMediaFileDuration", duration, file?.name, file?.type);
        message.info({
          position: "top",
          content: $$t("create.select_audio_or_video"),
        });
        reject("not audio");
        return;
      }
    } catch (e) {
      try {
        const outputfile = await ffmpegUtil.transFileToMp3(file);
        let duration = 0;
        if (outputfile) {
          duration = await tools.getMediaFileDuration(outputfile.file);
        }
        if (duration > 0) {
          if (duration < 10) {
            message.info({
              position: "top",

              content: $$tValue("create.min_file_duration", {
                duration: 10,
              }),
            });
            reject("min file duration");
          } else {
            renderData.duration = duration;
            renderData.file = outputfile.file;
            resolve();
          }
        } else {
          console.log(
            "transFileToMp3 getMediaFileDuration",
            duration,
            file?.name,
            file?.type
          );
          message.info({
            position: "top",
            content: $$t("create.select_audio_or_video"),
          });
          reject("not audio");
          return;
        }
      } catch (e) {
        console.log("not audio", e, file?.name, file?.type);
        message.info({
          position: "top",
          content:
            fileType == "video"
              ? $$t("create.select_video_error")
              : $$t("create.select_audio_error"),
        });
        reject("not audio");
      }
    }
  });
};

const doInitEditFile = async (filep, isLink) => {
  let file = renderData.file ?? filep;
  renderData.editFileName = file?.name
    ?.replace(/.[a-zA-Z0-9]+$/, "")
    ?.slice(0, 60);
  console.log("doInitEditFile", file.type, file);
  window.curSelectFile = file;
  const closeMsg = message.loading({
    content: isLink ? $$t("create.parsing_link") : $$t("create.extract_song"),
  });
  let decodeData = null;
  let blobUrl = null;
  let duration = 0;
  try {
    decodeData = await clipUtil.getDecodeDataByFile(file);
    duration = decodeData.duration;
    blobUrl = (window.URL || window.webkitURL).createObjectURL(file);
  } catch (e) {
    try {
      console.log("name:", file.name, "type:", file.type, "size:", file.size);
      const outputfile = await ffmpegUtil.transFileToMp3(file);
      file = outputfile.file;
      blobUrl = outputfile.blobUrl;
      decodeData = await clipUtil.getDecodeDataByFile(file);
      duration = decodeData.duration;
    } catch (e) {
      console.error("handleAfterReaderr", e);
      closeMsg.clear();
      message.info({
        content: $$t("create.extract_song_failed"),
      });
      return;
    }
  }
  renderData.fileTemp = file;

  console.log("renderEditFile", renderData.clipSourceData);
  closeMsg.clear();
  renderData.editFilePopupVisible = true;
  nextTick().then(() => {
    renderData.clipSourceData = {
      duration: duration,
      isUpload: true,
      blobUrl: blobUrl,
      url: null,
      type: "audio/wav",
      decodeData,
    };
  });
};

const handleEditFileCompleted = async (fileData, close) => {
  const { getClipedExportData, data } = fileData;
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.saving"),
  });
  let saveData = null;
  try {
    let clipedExportData = await getClipedExportData();
    if (clipedExportData.blob.type != "audio/mp3") {
      try {
        let transfile = await ffmpegUtil.transFileToMp3(
          new File([clipedExportData.blob], "output.wav", { type: "audio/wav" })
        );
        clipedExportData.url = transfile.blobUrl;
        clipedExportData.blob = transfile.blob;
        clipedExportData.file = transfile.file;
      } catch (e) {
        console.error("transFileToMp3 error", e);
      }
    }
    const fileSaveData = {
      url: clipedExportData.url,
      filename: data.filename,
      duration: clipedExportData.duration,
    };

    const objectStorageRes = await objectStorage.uploadFileToObjectStorage(
      clipedExportData.file,
      (obj) => {
        renderData.uploadCallbackData = obj;
      }
    );
    saveData = {
      url: objectStorageRes.pathKey,
      duration_milliseconds: Math.ceil(fileSaveData.duration * 1000),
      upload_link: null,
      // feed_id: draftDataStore.feed_id,
      title: fileSaveData.filename,
      source_type: 2,
      resource: null,
    };
  } catch (e) {
    closeMsg.clear();
    console.error("uploadFileToObjectStorage error", e);
    message.error({
      position: "top",
      content: $$t("create.save_failed"),
    });
    return;
  }

  saveVocal(saveData, close);
};

const saveVocal = async (saveData, close) => {
  const closeMsg = message.loading({
    position: "center",
    content: $$t("create.vocal_Extracting"),
  });

  apiReferMusic
    .addVocalMusic(saveData)
    .then((res) => {
      closeMsg?.clear();
      if (res.code == 200 && res.data) {
        renderData.file = null;
        emits("saveSuccess", res.data);
        close?.();
        renderData.clipSourceData = null;
      } else {
        if (res.code == 6308) {
          message.error({
            position: "top",
            content: $$t("create.vocal_effective_voice"),
          });
          renderData.file = null;
        } else if (res.code == 6351) {
          message.info({
            position: "top",
            content: $$t("create.generate_vocal_audit_failed"),
          });
        } else if (res.code == 6320) {
          message.error({
            position: "top",
            content: $$t("create.song_cover_auditing_failed"),
          });
        } else if (res.code == 6316) {
          message.error({
            position: "top",
            content: $$t("create.song_title_audit_failed"),
          });
        } else {
          message.error({
            position: "top",
            content: $$t("create.vocal_extract_song_failed"),
          });
        }
      }
    })
    .catch((err) => {
      closeMsg?.clear();
      console.error("addReferenceMusic error", err);
      message.error({
        position: "top",
        content: $$t("create.vocal_extract_song_failed"),
      });
    });
};

onMounted(() => {
  nextTick(() => {
    initUploadContent();
  });
});
</script>
<style lang="scss">
.add-vocal-file-container {
  position: relative;
  --filepond-height: 86px;

  .add-music-reference-edit-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .add-vocal-file-main {
    height: var(--filepond-height);
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(148, 173, 255, 0.1);
    position: relative;
    &:hover {
      background: rgba(148, 173, 255, 0.2);
    }
    .add-vocal-new-corner-mark {
      height: 32px;
      width: 32px;
      position: absolute;
      top: 0;
      right: 0;
      background: url("@/assets/img/new-corner-mark.png");
      background-size: 100% 100%;
      border-radius: 0 12px 0 0;
      overflow: hidden;
      span {
        position: absolute;
        font-family: HarmonyOS Sans SC;
        height: 20px;
        width: 44px;
        font-size: 9px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: #4c2a87;
        transform: rotate(45deg);
      }
    }
  }
  .add-vocal-file-desc {
    font-family: HarmonyOS Sans SC;
    font-size: 11px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    margin: 8px auto 0 auto;
    max-width: 200px;
  }
  .add-vocal-file-selectfile {
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      height: 20px;
      width: 20px;
      min-width: 20px;
      background: url("@/assets/img/upload-white-ico.png") no-repeat center;
      background-size: 100% 100%;
    }
    span {
      margin-left: 4px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
    }
    label.vip_plan {
      min-width: max-content;
      height: 14px;
      border-radius: 2px;
      background: linear-gradient(
        110deg,
        #ffe08b 0%,
        #fff7d0 47%,
        #ffe08b 100%
      );
      padding: 0 3px;
      line-height: 14px;
      font-family: Source Han Sans;
      font-size: 8px;
      font-weight: 500;
      color: #3d2d00;
      margin: 0 0 0 8px;
    }
  }
  .filepond--root {
    height: var(--filepond-height) !important;
    min-height: var(--filepond-height) !important;
    background: transparent;
    box-shadow: none;
    border-radius: var(--filepond-height);
    align-items: center;
    justify-content: center;
    border-radius: var(--filepond-height);
    margin: 0;
    .filepond--wrapper {
      height: var(--filepond-height) !important;
      border-radius: var(--filepond-height);
    }
    .filepond--browser.filepond--browser {
      height: 0;
    }
    .filepond--list-scroller {
      display: none;
    }
    .filepond--credits {
      display: none;
    }

    .filepond--panel-root {
      border-radius: 0.5em;
      background: transparent;
      box-shadow: none;
      border-radius: var(--filepond-height);
      display: none;
    }

    .filepond--assistant {
      display: block;
    }
    .filepond--drop-label {
      display: block;
      visibility: visible !important;
      transform: translate3d(0px, 0, 0px) !important;
      height: var(--filepond-height) !important;
      border-radius: var(--filepond-height) !important;
      min-height: var(--filepond-height) !important;
      opacity: 1 !important;
      pointer-events: auto !important;
      & > label {
        width: 0;
        height: 0;
        overflow: hidden;
        padding: 0;
      }
    }
    &[data-hopper-state="drag-over"] {
      .add-vocal-file-main {
        border: 1px dashed #94adff;
      }
    }
  }
  &.add-vocal-file-cn {
     --filepond-height: 56px;
    .add-vocal-file-main {
      --filepond-height: 56px;
    }
    .add-vocal-file-desc {
      display: none;
    }
  }
  &.add-vocal-file-container--mobile {
    --filepond-height: 90px;
    .add-vocal-file-main {
      padding: 0 0px;
      height: 90px;
      i {
        height: 16px;
        width: 16px;
        min-width: 16px;
      }
      span {
        font-size: 13px;
      }
      .vip_plan {
        margin: 0 0 0 4px;
      }
      .add-vocal-file-desc {
        margin: 8px auto 0 auto;
        padding: 0 8px;
        font-size: 11px;
      }
    }
  }
}
</style>
